import React, { useEffect, useState } from 'react';
import Nav from '../../components/Nav';
import DashboardSidebar from '../../components/DashboardSidebar';
import { LineChart } from '@mui/x-charts';
import ApiService from '../../services/ApiService';
import formatDate from '../../services/formatDate';

const EarningList = () => {

    const [active, setActive] = useState(true);
    const [filter, setFilter] = useState('year'); 
    const [orders, setOrders] = useState([]);

    const getOrders = async () => {

        const now = new Date();
        const mm = String(now.getMonth() + 1).padStart(2, '0');
        const yyyy = now.getFullYear();
        const month = `${yyyy}-${mm}`;
        const year = `${yyyy}`; 
        const filterDate = filter === 'year' ? year : month;

        try {
            const response = await ApiService.get(`/cms/orders?limit=100000&expiring_at=${filterDate}`);

            setOrders(response?.contents?.map(order => {
                return {
                    _id: order?._id,
                    earnings: order?.data?.amount,
                    date: formatDate(order?.data?.expiring_at, false),
                };
            }) || []);
        } catch (err) {
            console.error("Error fetching orders:", err);
        } finally {
        }
    };

    useEffect(() => {
        getOrders();
    }, [filter]);

    return (
        <div className="tyn-root dashboard earning-list">
            <Nav />
            <div className="tyn-content tyn-content-full-height tyn-chatbot tyn-chatbot-page has-aside-base">
                <DashboardSidebar active="Total Earnings" setter={setActive} />
                <div className={`tyn-main tyn-content-inner ${active && 'main-shown' || ''}`} id="tynMain">
                    <ul className="tyn-list-inline d-md-none translate-middle position-absolute start-50 z-1">
                        <li>
                            <button className="btn btn-icon btn-pill btn-white js-toggle-main" onClick={() => setActive(false)}>
                                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="bi bi-x-lg" viewBox="0 0 16 16">
                                    <path d="M2.146 2.854a.5.5 0 1 1 .708-.708L8 7.293l5.146-5.147a.5.5 0 0 1 .708.708L8.707 8l5.147 5.146a.5.5 0 0 1-.708.708L8 8.707l-5.146 5.147a.5.5 0 0 1-.708-.708L7.293 8z" />
                                </svg>
                            </button>
                        </li>
                    </ul>

                    <div className="container">
                        <div className="tyn-profile d-flex align-items-center justify-content-between px-5 py-4">
                            <div>
                                <h3 className="text-center">Earnings</h3>
                            </div>
                            <div className='buttons'>
                                <button className={`btn ${filter === 'month' ? 'btn-primary' : 'btn-outline-primary'}`} onClick={() => setFilter('month')}>
                                    Current Month
                                </button>
                                <button className={`btn ms-2 ${filter === 'year' ? 'btn-primary' : 'btn-outline-primary'}`} onClick={() => setFilter('year')}>
                                    Current Year
                                </button>
                            </div>
                        </div>

                        <div className="tyn-profile">
                            <div className="tyn-profile-details mt-4">
                                <LineChart 
                                    height={500}
                                    xAxis={[
                                        { data: orders?.map(item => item.date), scaleType: 'band' },
                                    ]}
                                    series={[
                                        {
                                            data: orders?.map(item => item?.earnings),
                                            color: '#1976d2',
                                            curve: 'natural',
                                        },
                                    ]}
                                    grid={{ x: true, y: true }}
                                    
                                />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default EarningList;
